import { render, staticRenderFns } from "./InputSwitchCpt.vue?vue&type=template&id=4ba16a27&"
import script from "./InputSwitchCpt.vue?vue&type=script&lang=ts&"
export * from "./InputSwitchCpt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports